(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cjd-stain-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = document.querySelectorAll('[data-cjd-stain-selector]');

    const woodData = {
      'White Oak': ['Low', 'Usually optional', 'Open grain; stain generally reads clearly. Test because undertones can shift cooler.'],
      'Red Oak': ['Low', 'Usually optional', 'Open grain and warmer natural tone can amplify reds and golds.'],
      'Maple': ['High', 'Strongly recommended', 'Dense wood can stain unevenly. A controlled test is especially important.'],
      'Knotty Alder': ['High', 'Strongly recommended', 'Known for uneven absorption and blotching. Test conditioner versus no conditioner.'],
      'Pine': ['High', 'Strongly recommended', 'Softwood can blotch heavily. Conditioner and side-by-side testing matter.'],
      'Mahogany': ['Low-Medium', 'Optional', 'Naturally warm red wood can push brown stains warmer.'],
      'Cherry': ['Medium', 'Recommended', 'Naturally warm wood darkens over time and can shift stain toward red.'],
      'Hickory': ['Medium', 'Recommended', 'Strong natural color variation can make one stain look different board to board.'],
      'Poplar': ['Medium-High', 'Recommended', 'Natural green or purple undertones can alter brown and gray stains.'],
      'Cedar': ['High', 'Strongly recommended', 'Soft, naturally warm wood can absorb unevenly and shift colors warmer.'],
      'Birch': ['High', 'Strongly recommended', 'Can blotch and darken unevenly with penetrating stain.']
    };

    const recommendations = {
      'Natural / Clear|Light': [['Natural','209'],['Rustic Beige','281'],['Fruitwood','241']],
      'Natural / Clear|Medium': [['Rustic Beige','281'],['Natural','209'],['Fruitwood','241']],
      'Natural / Clear|Dark': [['Rustic Beige','281'],['Mocha','280'],['Provincial','211']],
      'Golden / Honey|Light': [['Golden Oak','210B'],['Honey','272'],['Golden Pecan','245']],
      'Golden / Honey|Medium': [['Ipswich Pine','221'],['Colonial Maple','223'],['Golden Oak','210B']],
      'Golden / Honey|Dark': [['Ipswich Pine','221'],['Colonial Maple','223'],['Mocha','280']],
      'Classic Brown|Light': [['Special Walnut','224'],['Early American','230'],['Provincial','211']],
      'Classic Brown|Medium': [['Provincial','211'],['Special Walnut','224'],['Early American','230']],
      'Classic Brown|Dark': [['English Chestnut','233'],['Mocha','280'],['Dark Walnut','2716']],
      'Warm / Red Brown|Light': [['Fruitwood','241'],['Golden Pecan','245'],['Red Oak','215']],
      'Warm / Red Brown|Medium': [['Red Oak','215'],['Gunstock','231'],['Cherry','235']],
      'Warm / Red Brown|Dark': [['Red Mahogany','225'],['Sedona Red','222'],['Red Chestnut','232']],
      'Gray / Weathered|Light': [['Weathered Oak','270'],['Driftwood','2126'],['Silvered Gray','282']],
      'Gray / Weathered|Medium': [['Classic Gray','271'],['Silvered Gray','282'],['Weathered Oak','270']],
      'Gray / Weathered|Dark': [['Slate','284'],['Phantom Gray','1089'],['Aged Barrel','283']],
      'Deep Brown / Black|Light': [['Mocha','280'],['Special Walnut','224'],['English Chestnut','233']],
      'Deep Brown / Black|Medium': [['Mocha','280'],['Dark Walnut','2716'],['Jacobean','2750']],
      'Deep Brown / Black|Dark': [['Dark Walnut','2716'],['Jacobean','2750'],['Ebony','2718']],
      'White / Washed|Light': [['Simply White','275'],['Natural','209'],['Rustic Beige','281']],
      'White / Washed|Medium': [['Simply White','275'],['Rustic Beige','281'],['Weathered Oak','270']],
      'White / Washed|Dark': [['Simply White','275'],['Classic Gray','271'],['Slate','284']],
      'Blue / Color|Light': [['Vintage Blue','288'],['Navy','286'],['Silvered Gray','282']],
      'Blue / Color|Medium': [['Vintage Blue','288'],['Navy','286'],['Classic Gray','271']],
      'Blue / Color|Dark': [['Navy','286'],['Vintage Blue','288'],['Slate','284']]
    };

    selectors.forEach((root) => {
      const wood = root.querySelector('[data-cjd-wood]');
      const look = root.querySelector('[data-cjd-look]');
      const depth = root.querySelector('[data-cjd-depth]');
      const run = root.querySelector('[data-cjd-run]');
      const risk = root.querySelector('[data-cjd-risk]');
      const conditioner = root.querySelector('[data-cjd-conditioner]');
      const note = root.querySelector('[data-cjd-note]');
      const cards = root.querySelector('[data-cjd-cards]');
      const sampleLink = root.querySelector('[data-cjd-sample-link]');
      let selectorStarted = false;

      const publish = (eventName, eventData) => {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(eventName, eventData);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...eventData });
      };

      const selectionData = () => ({
        wood_species: wood.value,
        color_family: look.value,
        stain_depth: depth.value,
        page_path: window.location.pathname
      });

      const markStarted = () => {
        if (selectorStarted) return;
        selectorStarted = true;
        publish('stain_selector_started', selectionData());
      };

      const render = () => {
        const woodInfo = woodData[wood.value];
        const picks = recommendations[`${look.value}|${depth.value}`] || [];

        risk.textContent = woodInfo[0];
        conditioner.textContent = woodInfo[1];
        note.textContent = woodInfo[2];

        cards.innerHTML = '';
        picks.forEach((pick, index) => {
          const card = document.createElement('div');
          card.className = 'cjd-stain-selector__card';
          card.innerHTML = `
            <div class="cjd-stain-selector__rank">${index + 1}</div>
            <div>
              <h4>${pick[0]}</h4>
              <p>Minwax Wood Finish · ${pick[1]}</p>
            </div>
          `;
          cards.appendChild(card);
        });
      };

      [wood, look, depth].forEach((field) => {
        field.addEventListener('change', markStarted);
      });

      run.addEventListener('click', () => {
        markStarted();
        render();
        publish('stain_recommendation_generated', selectionData());
      });

      sampleLink.addEventListener('click', () => {
        publish('stain_samples_clicked', {
          ...selectionData(),
          destination_url: sampleLink.href
        });
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
